// constants/products.js

export const products = [

  {
    id: 1,
    key: "ino",
    title: " ٪100 عربیکا",
    origin:  "عربیکای اتیوپی٬کلمبیا و برزیل",
    description:
      "قهوه‌ای متعادل و خوش‌عطر با نت‌های میوه‌ای و گلی، مناسب برای کسانی که طعم‌های ظریف‌تر را می‌پسندند.",
    flavorNotes: [
      "میوه‌ای",
      "گل‌دار",
      "شکلاتی",
      "شیرین",
    ],
    profile: {
      acidity: "ملایم",
      body: "متوسط",
      roast: "متوسط",
    },

    images: [
      "/images/100arabica-.jpeg",
    ],
    variants: [
      { weight: "1kg", label: "۱ کیلویی" },
      { weight: "1Karton", label: "کارتن" },
      { weight: "Powder", label: "آسیاب" }
    ],
  },
  {
    id: 2,
    key: "ino",
    title: "50٪ روبوستا / ٪50 عربیکا",
    origin: "عربیکای هند و کلمبیا + روبوستای اوگاندا و هند",
    description: "ترکیبی متعادل با بادی متوسط، تلخی کنترل‌شده و نت‌های شیرین و خاکی.",
    flavorNotes: [
      "آجیلی",
      "شیرین",
      "خاکی",
      "میوه ای",
    ],
    profile: {
      acidity: "ظریف و ملایم",
      body: "متوسط",
      roast: "متوسط",
    },
    images: [
      "/images/50robusta-.jpeg",
    ],
    variants: [
      { weight: "1kg", label: "۱ کیلویی" },
      { weight: "1Karton", label: "کارتن" },
      { weight: "Powder", label: "آسیاب" }
    ],
  },
  {
    id: 3,
    key: "ino",
    title: "80٪ عربیکا / 20٪ روبوستا",
    origin: "عربیکای اتیوپی٬کلمبیا٬برزیل + رویوستای اوگاندا",
    description: "ترکیبی متعادل و خوش‌عطر با بادی مخملی و نت‌های میوه‌ای، شیرین و شکلاتی.",
    flavorNotes: [
      "میوه ای",
      "شیرین",
      "آجیلی",
      "شکلات",
    ],
    profile: {
      acidity: "بالا با ویژگی میوه ای و گلی",
      body: "متوسط و مخملی",
      roast: "متوسط",
    },
    images: [
      "/images/20robusta-.jpeg",
    ],
    variants: [
      { weight: "1kg", label: "۱ کیلویی" },
      { weight: "1Karton", label: "کارتن" },
      { weight: "Powder", label: "آسیاب" }
    ],
  },
  {
    id: 4,
    key: "ino",
    title: "70٪ روبوستا / 30٪ عربیکا",
    origin:  "عربیکای برزیل + رویوستای اوگاندا و هند",
    description: "قهوه‌ای قدرتمند با بادی بالا، اسیدیته بسیار کم و طعمی قوی و شکلاتی.",
    flavorNotes: [
      "ادویه ای",
      "قوی و آجیلی",
    ],
    profile: {
      acidity: "بسیار کم و ملایم",
      body: "بالا و سنگین",
      roast: "متوسط رو به تیره/ شکلاتی",
    },
    images: [
      "/images/70robusta-.jpeg",
    ],
    variants: [
      { weight: "1kg", label: "۱ کیلویی" },
      { weight: "1Karton", label: "کارتن" },
      { weight: "Powder", label: "آسیاب" }
    ],
  },
  {
    id: 5,
    key: "ino",
    title: "100٪ روبوستا",
    origin: "روبوستای اوگاندا و هند"
    ,
    description: "قهوه‌ای غلیظ و قدرتمند با بادی سنگین، اسیدیته بسیار کم و طعم تلخ و شکلاتی.",
    flavorNotes: [
      "قوی و تلخ"
    ],
    profile: {
      acidity: "بسیار کم",
      body: "سنگین٬غلیظ و پر حچم",
      roast: "تیره/ شکلاتی",
    },
    images: [
      "/images/100robusta-.jpeg",
    ],
    variants: [
      { weight: "1kg", label: "۱ کیلویی" },
      { weight: "1Karton", label: "کارتن" },
      { weight: "Powder", label: "آسیاب" }
    ],
  },
];
